import cloneDeep from 'lodash/cloneDeep';
import { IServerMessageBodyNoticeUserNewInfo, IServerMessageBodyNoticeUserLeave } from '@tencent/docs-connection/lib/interface';
import { getRealUid } from './user-manager';
import { IEventManager } from '@tencent/slide-sdk-model';
import { ICollaboratorUserManager } from '../core/interfaces/collaborator-user-manager.interface';

/**
 * 协作者用户管理
 */
class CollaboratorUserManager implements ICollaboratorUserManager {
    public userList: { userId: string }[] = [];

    public constructor(sdkEventManager: IEventManager) {
        sdkEventManager.socketEvents.onUserEnter(this.onUserEnter.bind(this));
        sdkEventManager.socketEvents.onUserLeave(this.onUserLeave.bind(this));
    }

    /** 增加用户 */
    private onUserEnter(userInfo: IServerMessageBodyNoticeUserNewInfo) {
        if (this.shouldBlockUser(userInfo) || this.userIsExist(userInfo.userId)) return;
        this.userList.unshift(userInfo);
        this.updateUserInfosInGlobal();
    }

    /** 删除用户 */
    private onUserLeave(userInfo: IServerMessageBodyNoticeUserLeave) {
        if (this.shouldBlockUser(userInfo) || !this.userIsExist(userInfo.userId)) return;
        const index = this.userList.findIndex(({ userId }) => userId === userInfo.userId);
        this.userList.splice(index, 1);
        this.updateUserInfosInGlobal();
    }

    /**
     * 为协作组件Collaboration提供数据(历史代码)
     */
    private updateUserInfosInGlobal() {
        window.clientVars.invitedUserInfos = cloneDeep(this.userList);
    }

    private userIsExist(userId: string) {
        return this.userList.find(({ userId: id }) => id === userId);
    }

    /** 是否屏蔽用户 */
    private shouldBlockUser({ userId }) {
        const isCorpWeChat = window.location.hostname === 'doc.weixin.qq.com';
        // 【企微】 屏蔽 <融合会议游客> 账号 (特征是二进制下有统一的前缀)
        if (isCorpWeChat) {
            const uin = getRealUid(userId);

            if (!window.BigInt) {
                // NOTE: 这个判断是有误差的，目的是不额外引入 BigInt polyfill；
                const prefix = +(uin.slice(0, -9));
                return prefix < 13102700 && prefix > 13102695;
            }

            return (BigInt(uin) >> BigInt(32)).toString() === '3050709';
        }

        return false;
    }
}

export default CollaboratorUserManager;
